<template>
  <div class="ac-card-content">
    <div class="ac-body-container">
      <img
        src="@shared/assets/img/logo/smart-maintenance-grey.png"
        class="ac-logo"
        alt="Smart Maintenance®"
      >
      <div class="ac-header">
        Smart Maintenance® Plan Details
      </div>
      <div class="ac-plan-container">
        <div class="ac-plan-header">
          <img
            src="@shared/assets/img/setting/plan-icon.svg"
            alt="Service Plans"
          >
          Create custom service plans
        </div>
        <div class="ac-plan-body">
          Easily incorporate SmartAC.com into your maintenance plan
          offerings.
        </div>
      </div>
      <div class="ac-plan-container">
        <div class="ac-plan-header">
          <img
            src="@shared/assets/img/setting/cc-full-icon.svg"
            alt="Comfort Credits"
          >
          Comfort Credits
        </div>
        <div class="ac-plan-body">
          Customize special offers when homeowners sign up for
          maintenance plans. Credits accumulate over time
          encouraging customer loyalty.
        </div>
      </div>
      <div class="ac-plan-container">
        <div class="ac-plan-header">
          <img
            src="@shared/assets/img/setting/signup-icon.svg"
            alt="Sign Up Bonuses"
          >
          Sign Up Bonuses
        </div>
        <div class="ac-plan-body">
          Add sign up bonuses to your plans, such as Comfort Credits
          and Filter Discount Vouchers, as an incentive for your
          customers.
        </div>
      </div>
      <div class="ac-plan-container">
        <div class="ac-plan-header">
          <img
            src="@shared/assets/img/setting/eye-icon.svg"
            alt="Archive"
          >
          Archiving a Plan
        </div>
        <div class="ac-plan-body">
          Archiving will remove the plan as an option for new
          customers. Preexisitng customers will not be affected and
          will remain on the plan.
        </div>
      </div>
      <div class="ac-plan-container">
        <div class="ac-plan-header">
          <img
            src="@shared/assets/img/setting/red-x-circle.svg"
            alt="Comfort Credits"
          >
          Deleting a Plan
        </div>
        <div class="ac-plan-body">
          If you would like to delete a plan, please contact your
          Partner Success Manager directly or email
          <a href="mailto:partners@smartac.com">
            partners@smartac.com.
          </a>
        </div>
      </div>
      <div class="ac-plan-container">
        <div class="ac-plan-header">
          <img
            src="@shared/assets/img/setting/edit-plan-icon.svg"
            alt="Comfort Credits"
          >
          Editing a Plan
        </div>
        <div class="ac-plan-body">
          If you would like to edit a plan, please contact your
          Partner Success Manager directly or email
          <a href="mailto:partners@smartac.com">
            partners@smartac.com.
          </a>
        </div>
      </div>
      <button
        type="button"
        class="ac-button"
        @click="close"
      >
        Cancel
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SmartMaintenanceInfo',
  props: {
    close: Function,
  },
};
</script>
